import { useGetForumGroupsQuery } from "api/queries/groups";
import { AsyncSelect } from "components/styleguide";
import AttendeeStatus from "enums/AttendeeStatus";
import { useTranslation } from "react-i18next";

import styles from "./styles.module.less";

type ForumGroupFilterSelectorProps = {
  onChange: (value: number | undefined) => void;
  forumId: number;
};

export const ForumGroupFilterSelector = ({ onChange, forumId }: ForumGroupFilterSelectorProps) => {
  const { t } = useTranslation();
  const forumGroupsQuery = useGetForumGroupsQuery({
    forumId,
    attendeeStatuses: [AttendeeStatus.Attending, AttendeeStatus.AttendingReplacement],
    orderBy: "primary",
    orderDir: "desc",
  });

  const optionsMapper = (response: NonNullable<typeof forumGroupsQuery.data>["data"]) =>
    response.map((group) => ({
      value: group.id,
      label: group.name,
    }));

  return (
    <AsyncSelect
      query={forumGroupsQuery}
      optionsMapper={optionsMapper}
      placeholder={t("Filter by Group")}
      className={styles.filter}
      allowClear
      onChange={onChange}
    />
  );
};
